import { MdOutlineClose } from "react-icons/md";

export default function FreeSlot(props) {
  const {
    rowId,
    time,
    setShowAlertModal,
    setShowModal,
    result,
    setCurrentRow,
    setCurrentTime,
    type=1
  } = props;

  return (
    <td
      style={{ width: "100px", height: "100px" }}
      onClick={(event) => {
        setCurrentTime(time);
        setCurrentRow(rowId);
        if (result === undefined) {
          setShowModal(true);
        } else {
          setShowAlertModal(true);
        }
      }}
    >
      {result !== undefined ? (
        <div className={`h-full w-full p-2 ${result.teacher.overtime?"bg-navy-200" :"bg-orange-200"} `}>
          <MdOutlineClose className={type===1? "float-right h-4 w-4 fill-red-600":"hidden" }/>
          <p>{result.lesson.name}</p>
          <p>{type===2? result.classroom.building+"->"+ result.classroom.number : result.teacher.lastname[0].toUpperCase() + ". "+result.teacher.firstname}</p>
          <p>{result.course.number + result.course.group}</p>
        </div>
      ) : (
        <span></span>
      )}
    </td>
  );
}
